import { DISCOUNT_LINE_PRODUCT_UUID, ORDER_LINE_TYPE, } from "../../../../assets/react/Webshop/types/ShoppingCart";
// ReactWebCart also sends product.uuid on the non-product lines that come from
// an order part, which the line types do not model.
const productUuid = (line) => { var _a; return "product" in line ? (_a = line.product) === null || _a === void 0 ? void 0 : _a.uuid : undefined; };
// The discount lines carry negative prices; these return the amount taken off.
const amountOff = (order, uuid) => -order.orderLines
    .filter((line) => line.type === ORDER_LINE_TYPE.DISCOUNT && productUuid(line) === uuid)
    .reduce((sum, line) => sum + line.linePrice, 0);
/** The amount that the voucher code took off the order. */
export const voucherDiscount = (order) => amountOff(order, DISCOUNT_LINE_PRODUCT_UUID.VOUCHER_CODE);
/** The amount of the user's account balance that paid for the order. */
export const accountCredit = (order) => amountOff(order, DISCOUNT_LINE_PRODUCT_UUID.ACCOUNT_BALANCE);
